export default {
  sortObjectByKey(object, key_name) {
    let allEntries = Object.values(object);
    return allEntries.sort((a,b) => {
      if (a[key_name] < b[key_name]) {
        return -1;
      }
      if (a[key_name] > b[key_name]) {
        return 1;
      }
      return 0;
    })
  },
  sort(moveFromIndex,toIndex, inArray) {
    let newlySortedArray = this.clone(inArray);

    let moveElement = inArray[moveFromIndex];

    newlySortedArray.splice(moveFromIndex, 1);
    newlySortedArray.splice(toIndex, 0, moveElement);

    return newlySortedArray;
  },
  find(id, models) {
    let models_array = models.filter(model => {
      return model.id === parseInt(id);
    });
    return models_array.length ? models_array[0] : null;
  },
  removeElementFromArray(array, removeIndex) {
    var index = array.indexOf(removeIndex);
    if (index > -1) {
      array.splice(index, 1);
    }
  },
  /**
   * Use this to remove an object (i.e. model) from an array based on an ID property
   *
   * @param object_array
   * @param id
   * @returns {*}
   */
  remove_object_from_array_by_id(object_array, id) {
    return object_array.filter((object) => {
      return object.id !== id;
    });
  },
  /**
   * Find the index of a matching value of an object in an array
   * @param array
   * @param property_name
   * @param property_value
   * @returns {*}
   */
  find_index_of_matching_element(array, property_name, property_value) {
    property_value = this.parse_id_if_needed(property_name, property_value);
    return array.filter(x => x !== null).findIndex(x => x[property_name] === property_value);
  },
  /**
   * Find the index of a matching Array element
   * @param array
   * @param needle
   * @returns {number}
   */
  find_index_of_matching_value(array, needle) {
    let valueIndex = -1;
    array.forEach((arrayValue, index) => {
      if (arrayValue === needle) {
        valueIndex = index;
      }
    });
    return valueIndex;
  },
  /**
   *
   * @param property_name
   * @param property_value
   */
  parse_id_if_needed(property_name, property_value) {
    if (property_name === 'id' || property_name.endsWith('_id')) {
      return this.parse_id(property_value);
    }
    return property_value;
  },
  parse_id(id) {
    if (!id) {
      return id;
    }

    id = parseInt(id);
    return id;
  },
  deep_clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  clone(obj) {
    return this.deep_clone(obj);

    // // Handle the 3 simple types, and null or undefined
    // if (null == obj || "object" != typeof obj) return obj;
    //
    // // Handle Date
    // if (obj instanceof Date) {
    //   let copy = new Date();
    //   copy.setTime(obj.getTime());
    //   return copy;
    // }
    //
    // // Handle Array
    // if (obj instanceof Array) {
    //   let copy = [];
    //   for (let i = 0, len = obj.length; i < len; i++) {
    //     copy[i] = this.clone(obj[i]);
    //   }
    //   return copy;
    // }
    //
    // // Handle Object
    // if (obj instanceof Object) {
    //   let copy = {};
    //   for (let attr in obj) {
    //     if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
    //   }
    //   return copy;
    // }
    //
    // throw new Error("Unable to copy obj! Its type isn't supported.");
  },
  get_random_from_array(array) {
    let index = Math.floor(Math.random() * array.length);
    return array[index];
  },
  // Helper function for dealing with replace or add during commits
  id_already_exists(array, id) {
    return this.find_index_of_matching_element(array, 'id', id) !== -1;
  },
  matches_filter_query(string, filter_queries, filter_columns = []) {

    if (this.is_object(string)) {
      string = this.filtered_nested_object_to_string(string, filter_columns);
    }

    // If not, we continue
    var filter_queries_OR_array = filter_queries.split('||');

    // If the query is empty, return true
    if (filter_queries.length < 1) {
      return true;
    }

    let normalized_string = this.normalized_string(string);

    var passed = false;
    filter_queries_OR_array.forEach(function (filter_query_AND_string) {
      var passes_filter = this.array_contains_query(normalized_string, filter_query_AND_string.trim()) ? true : false;
      if (passes_filter) {
        passed = true;
      }
    }.bind(this));
    return passed;
  },
  array_contains_query(string, filter_queries_array) {

    // var filter_queries_AND_array = filter_queries_array.split(' ');
    var filter_queries_AND_array = filter_queries_array.match(/[^\s"]+|"([^"]*)"/g); // Single words to elements and "fixed string of words" to elements

    // When the array is empty, return true
    if (filter_queries_AND_array == null) {
      return true;
    }

    var passed = true;
    filter_queries_AND_array.forEach(function (filter_query) {
      var passes_filter = this.string_contains_query(string, filter_query.trim()) ? true : false;
      if (!passes_filter) {
        passed = false;
      }
    }.bind(this));
    return passed;
  },
  string_contains_query(string, query) {
    string = string.toLowerCase();
    query = query.toLowerCase();

    // If it's an empty string (meaning it's part of an OR query), return false.
    // This keeps the overview cleaner
    if (query.length < 1) {
      return 0;
    }
    // If there are quotation marks, now's the time to remove them
    query = query.replace(/"/g, "");

    // If there's a single | in there because the user is about to type 2, filter it
    query = query.replace("|", "");

    // If there's an ! in there, it should pass if that name is NOT in there
    if (query.includes('!')) {
      query = query.replace('!', ''); // Replaced the exclamation mark ofcourse
      return this.regexIndexOf(string, query) === -1;
    }
    return this.regexIndexOf(string, query) !== -1;
  },
  is_object(item) {
    return (typeof item === "object" && !Array.isArray(item) && item !== null);
  },
  filtered_nested_object_to_string(object, filter_columns = [], current_column = '') {
    let string = '';

    Object.keys(object).forEach(key => {
      let value = object[key];
      // console.log(key);

      // For readability. What we call filter_columns (referring to the DB table columns) are actually keys here
      // When the
      let column = current_column;
      // If the column is not NaN, we add it to the dotted notation. By doing this, we are unaffected by nested
      // objects or array indexes
      // Changing 0.models.value.3.more_values to models.value.more_values
      if (isNaN(parseInt(key))) {
        column = (column + '.' + key).replace(/^\./g, ''); // We trim the first ., if need be
      }

      // If it's an object, we continue the loop
      // If it's an array, we continue the loop
      if ((typeof value === 'object' || Array.isArray(value)) && value !== null) {
        string = string + ' ' + this.filtered_nested_object_to_string(value, filter_columns, column);
      } else {
        // Then finally, we check if we should add this value, based on the given filter columns
        // When there are no given filter columns, we add it straight away
        // Or if the current column is in the filter columns
        if (filter_columns.length === 0 || filter_columns.includes(column)) {
          string = string + ' ' + value;
        }
      }
    });

    // Removing excess spaces before the final return
    return string.replace(/\s+/g, ' ');
  },
  regexIndexOf(string, regex_search) {
    // Escape for regex usage. Hier vervangen we alle special characters
    // en escapen ze zodat ze in de regex als string, en niet als modifier gezien worden
    regex_search = regex_search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

    let indexInSuffix = string.search(regex_search);
    return indexInSuffix < 0 ? indexInSuffix : indexInSuffix;
  },
  normalized_string(string) {
    return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  },

  roundDownToTwo(number) {
    return Math.round(number * 100) / 100
  }

};
